module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/3@2x_4e63365bfb7cebba4882565f2ea89093.png";